import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Detail = lazy(() => import('./Detail'))

//	///////////////////////
//	MARK: EXPORTS
// V10, V11 — la fiche d'un assessment, à la flotte ; la liste vit dans la bibliothèque (onglet Assessments).
export const MaintenanceAssessmentRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--maintenance--fleet']}>
    <Route path='file/:assessmentId/*' element={<Detail />} />
  </SubRouter>
))
